const c = {
  name: "WorldNorthAmerica",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M19.3,8c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C18.7,6.7,19.3,7.3,19.3,8z"/>
		<path class="st0" d="M17.3,11c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2s0.6-1.2,1.2-1.2C16.7,9.7,17.3,10.3,17.3,11z"/>
		<path class="st0" d="M21.3,11c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2s0.6-1.2,1.2-1.2C20.7,9.7,21.3,10.3,21.3,11z"/>
		<path class="st0" d="M24,12.2c0.7,0,1.2-0.6,1.2-1.2S24.7,9.7,24,9.7c-0.7,0-1.2,0.6-1.2,1.2S23.3,12.2,24,12.2z"/>
		<path class="st0" d="M33.3,11c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2s0.6-1.2,1.2-1.2C32.7,9.7,33.3,10.3,33.3,11z"/>
		<path class="st0" d="M10,15.2c0.7,0,1.2-0.6,1.2-1.2s-0.6-1.2-1.2-1.2c-0.7,0-1.3,0.6-1.3,1.2S9.3,15.2,10,15.2z"/>
		<path class="st0" d="M15.3,14c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2s0.6-1.2,1.2-1.2C14.7,12.7,15.3,13.3,15.3,14z"/>
		<path class="st0" d="M18,15.2c0.7,0,1.2-0.6,1.2-1.2s-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2S17.3,15.2,18,15.2z"/>
		<path class="st0" d="M23.3,14c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2s0.6-1.2,1.2-1.2C22.7,12.7,23.3,13.3,23.3,14z"/>
		<path class="st0" d="M26,15.2c0.7,0,1.2-0.6,1.2-1.2s-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2S25.3,15.2,26,15.2z"/>
		<path class="st0" d="M35.3,14c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2s0.6-1.2,1.2-1.2C34.7,12.7,35.3,13.3,35.3,14z"/>
		<path class="st0" d="M6,15.2c0.7,0,1.2-0.6,1.2-1.2S6.7,12.7,6,12.7c-0.7,0-1.2,0.6-1.2,1.2S5.3,15.2,6,15.2z"/>
		<path class="st0" d="M22,9.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C20.8,8.7,21.3,9.2,22,9.2z"/>
		<path class="st0" d="M27.3,8c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C26.7,6.7,27.3,7.3,27.3,8z"/>
		<path class="st0" d="M30,9.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C28.8,8.7,29.3,9.2,30,9.2z"/>
		<path class="st0" d="M9.3,17c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C8.7,15.7,9.3,16.3,9.3,17z"/>
		<path class="st0" d="M12,18.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C10.8,17.7,11.3,18.2,12,18.2z"
			/>
		<path class="st0" d="M17.3,17c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C16.7,15.7,17.3,16.3,17.3,17z"
			/>
		<path class="st0" d="M20,18.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C18.8,17.7,19.3,18.2,20,18.2z"
			/>
		<path class="st0" d="M25.3,17c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C24.7,15.7,25.3,16.3,25.3,17z"
			/>
		<path class="st0" d="M28,18.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C26.8,17.7,27.3,18.2,28,18.2z"
			/>
		<path class="st0" d="M5.3,17c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.3-0.6-1.3-1.2c0-0.7,0.6-1.2,1.3-1.2C4.7,15.7,5.3,16.3,5.3,17z"/>
		<path class="st0" d="M14,21.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C12.8,20.7,13.3,21.2,14,21.2z"
			/>
		<path class="st0" d="M19.3,20c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C18.7,18.7,19.3,19.3,19.3,20z"
			/>
		<path class="st0" d="M22,21.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C20.8,20.7,21.3,21.2,22,21.2z"
			/>
		<path class="st0" d="M27.3,20c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C26.7,18.7,27.3,19.3,27.3,20z"
			/>
		<path class="st0" d="M30,21.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C28.8,20.7,29.3,21.2,30,21.2z"
			/>
		<path class="st0" d="M17.3,23c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C16.7,21.7,17.3,22.3,17.3,23z"
			/>
		<path class="st0" d="M20,24.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C18.8,23.7,19.3,24.2,20,24.2z"
			/>
		<path class="st0" d="M25.3,23c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C24.7,21.7,25.3,22.3,25.3,23z"
			/>
		<path class="st0" d="M18,27.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C16.8,26.7,17.3,27.2,18,27.2z"
			/>
		<path class="st0" d="M23.3,26c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C22.7,24.7,23.3,25.3,23.3,26z"
			/>
		<path class="st0" d="M20,30.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C18.8,29.7,19.3,30.2,20,30.2z"
			/>
		<path class="st0" d="M25.3,29c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C24.7,27.7,25.3,28.3,25.3,29z"
			/>
		<path class="st0" d="M28,30.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C26.8,29.7,27.3,30.2,28,30.2z"
			/>
		<path class="st0" d="M27.3,32c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.3,1.2-1.3C26.7,30.7,27.3,31.3,27.3,32z"
			/>
		<path class="st0" d="M30,33.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.3-1.2-1.3c-0.7,0-1.2,0.6-1.2,1.3C28.8,32.7,29.3,33.2,30,33.2z"
			/>
		<path class="st0" d="M0,20C0,9,9,0,20,0s20,9,20,20c0,11-9,20-20,20S0,31,0,20z M29.3,35c0,0.2,0,0.3-0.1,0.5v0
			C34.4,32.3,38,26.6,38,20c0-2.8-0.6-5.4-1.8-7.8c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0c-0.7,0-1.2-0.6-1.2-1.2c0-0.3,0.1-0.6,0.3-0.8
			c-0.2-0.3-0.5-0.7-0.7-1c-0.1,0-0.2,0.1-0.4,0.1c-0.7,0-1.2-0.6-1.2-1.2c0-0.2,0.1-0.4,0.1-0.5C29.6,4.1,25.1,2,20,2
			C10.1,2,2,10.1,2,20s8.1,18,18,18c2.8,0,5.4-0.7,7.8-1.8c-0.6-0.1-1-0.6-1-1.2c0-0.7,0.6-1.2,1.2-1.2C28.7,33.7,29.3,34.3,29.3,35
			z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as WorldNorthAmerica
};
